import Header from "components/Headers/Header";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Col, Container, Row, Spinner } from "reactstrap";
import { refundsStates } from "store/actions/additionalEarningAction";

const Refunds = () => {
  const dispatch = useDispatch();
  const [dataLoader, setDataLoader] = useState(true);

  const refundsInfoPoints = [
    "The rating types include Satisfied, NS (Not Satisfied), R-ST (Rude - Short-Time), and No-Rating.",
    "The Admin can only view the ratings received by athletes during their meets or chats with fans, as well as the amount refunded to fans based on their submitted ratings.",
  ];
  const refundsInfoTitle = "Refunds Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  useEffect(() => {
    dispatch(
      refundsStates(() => {
        setDataLoader(false);
      })
    );
  }, []);

  const { totalRefunds } = useSelector((state) => state.earnings);

  return (
    <>
      <Header />
      <Container className="mb-5" fluid>
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>
        <Row className="d-flex justify-content-center align-items-center">
          <Col lg={4} sm={6} align="center">
            <h1 className="card-title">All Refunds Data</h1>
          </Col>
        </Row>
        {dataLoader ? (
          <div className="text-center mt-4">
            <Spinner color="primary" />
          </div>
        ) : (
          <Row className="justify-content-center ">
            <Col lg={4} sm={6} align="center">
              <Link
                to={{
                  pathname: "/admin/refund-details",
                  state: {
                    RefundsName: "satisfied",
                  },
                }}
              >
                <div className="dashboard-card">
                  <p className="dashboard-card-heading--calculaterefund">
                    Satisfied
                  </p>
                  <p className="dashboard-card-numbers--calculaterefund">
                    {totalRefunds?.satisfied?.totalChats}
                  </p>
                  <p className="dashboard-card-title--calculaterefund">
                    ({totalRefunds?.satisfied?.totalRefunds}$)
                  </p>
                </div>
              </Link>
            </Col>
            <Col lg={4} sm={6} align="center">
              <Link
                to={{
                  pathname: "/admin/refund-details",
                  state: {
                    RefundsName: "NS",
                  },
                }}
              >
                <div className="dashboard-card">
                  <p className="dashboard-card-heading--calculaterefund">NS</p>
                  <p className="dashboard-card-numbers--calculaterefund">
                    {totalRefunds?.NS?.totalChats}
                  </p>
                  <p className="dashboard-card-title--calculaterefund">
                    ({totalRefunds?.NS?.totalRefunds}$)
                  </p>
                </div>
              </Link>
            </Col>
            <Col lg={4} sm={6} align="center">
              <Link
                to={{
                  pathname: "/admin/refund-details",
                  state: {
                    RefundsName: "RST",
                  },
                }}
              >
                <div className="dashboard-card">
                  <p className="dashboard-card-heading--calculaterefund">
                    R-ST
                  </p>
                  <p className="dashboard-card-numbers--calculaterefund">
                    {totalRefunds?.RST?.totalChats}
                  </p>
                  <p className="dashboard-card-title--calculaterefund">
                    ({totalRefunds?.RST?.totalRefunds}$)
                  </p>
                </div>
              </Link>
            </Col>
            <Col lg={4} sm={6} align="center">
              <Link
                to={{
                  pathname: "/admin/refund-details",
                  state: {
                    RefundsName: "noRating",
                  },
                }}
              >
                <div className="dashboard-card">
                  <p className="dashboard-card-heading--calculaterefund">
                    No-Rating
                  </p>
                  <p className="dashboard-card-numbers--calculaterefund">
                    {totalRefunds?.noRating?.totalChats}
                  </p>
                  <p className="dashboard-card-title--calculaterefund">
                    ({totalRefunds?.noRating?.totalRefunds}$)
                  </p>
                </div>
              </Link>
            </Col>
          </Row>
        )}
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={refundsInfoPoints}
        title={refundsInfoTitle}
      />
    </>
  );
};

export default Refunds;
